/**
 * Platform Admin Routes
 * Routes for super_user platform administration
 */

import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { LazyPage } from "../helpers";

// Platform Admin Pages (super_user only)
const PlatformDashboardPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformDashboardPage })));
const PlatformTenantsPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformTenantsPage })));
const PlatformTenantDetailPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformTenantDetailPage })));
const PlatformPricingPlansPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformPricingPlansPage })));
const PlatformInvoicesPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformInvoicesPage })));
const PlatformSubscriptionEditPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformSubscriptionEditPage })));
const PlatformBillingContactEditPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformBillingContactEditPage })));
const PlatformSettingsPage = lazy(() => import("@/pages/platform").then(m => ({ default: m.PlatformSettingsPage })));

const superUserOnly = ["super_user"] as const;

export const platformRoutes: RouteObject[] = [
  {
    path: "/platform",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformDashboardPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/dashboard",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformDashboardPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/tenants",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformTenantsPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/tenants/:tenantId",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformTenantDetailPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/pricing-plans",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformPricingPlansPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/invoices",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformInvoicesPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/invoices/:invoiceId",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformInvoicesPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/tenants/:tenantId/subscription/edit",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformSubscriptionEditPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/tenants/:tenantId/subscription/new",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformSubscriptionEditPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/tenants/:tenantId/billing-contact/edit",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformBillingContactEditPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/platform/settings",
    element: (
      <ProtectedRoute roles={[...superUserOnly]}>
        <AppShell>
          <LazyPage><PlatformSettingsPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
];
